import { get } from 'vio-libs';
export function getMapFeatureSources(organizationSlug) {
    return get(`map-feature-sources?organization=${organizationSlug}`);
}
